import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { Subscription } from 'rxjs';

@Component({
  selector: 'nebula-table-actions',
  templateUrl: './nebula-table-actions.component.html',
  styleUrls: ['./nebula-table-actions.component.scss']
})
export class NebulaTableActionsComponent implements AfterViewInit, OnDestroy {

  @Input() public row: ElementRef;
  @Input() public selectedRow: ElementRef;
  @Input() public canDelete = true;
  @Input() public canEdit = true;
  @Output() selectedRowChange = new EventEmitter();
  @Output() edit = new EventEmitter();
  @Output() delete = new EventEmitter();
  @ViewChild(MatMenuTrigger, { static: false }) trigger: MatMenuTrigger;
  private menuOpenedSubscription: Subscription;
  private menuClosedSubscription: Subscription;

  constructor() { }

  ngAfterViewInit() {
    this.menuOpenedSubscription = this.trigger?.menuOpened.subscribe(() => {
      setTimeout(() => {
        this.selectedRowChange.emit(this.row);
      });
    });
    this.menuClosedSubscription = this.trigger?.menuClosed.subscribe(() => {
      this.selectedRowChange.emit(null);
    });
  }

  ngOnDestroy() {
    this.menuOpenedSubscription?.unsubscribe();
    this.menuClosedSubscription?.unsubscribe();
  }

  editItem() {
    this.edit.emit(null);
  }

  deleteItem() {
    this.delete.emit(null);
  }

}
